import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';

import { OfferService, SpaceService, UserService } from '../../../support/services/api';
import useBasket from '../../../model/useBasket';

import SpaceNotExist from './components/SpaceNotExist';
import Header from './components/Header';
import OffersList from './components/OffersList';
import OfferModal from './components/OfferModal';

import './styles.css';

function Profile() {
  const { nickname } = useParams();
  const { commands: basketCommands } = useBasket();

  const {
    data: space, isLoading, isFetching, isIdle,
  } = useQuery(
    ['spaces', { nickname }],
    () => SpaceService().getByNicknames([nickname]),
    {
      keepPreviousData: true,
      enabled: !!nickname,
      select: (res) => res.producers[0],
    },
  );

  const { data: users } = useQuery(
    ['users', { nickname }],
    () => UserService().getByIds(space?.usersIds),
    {
      keepPreviousData: true,
      enabled: !!space?.usersIds?.length,
    },
  );

  const { data: offers } = useQuery(
    ['offers', { nickname }],
    () => OfferService().getByNickname(nickname).then((res) => res.offers),
    {
      keepPreviousData: true,
      enabled: !!nickname && !!space,
    },
  );
    
  return (
    <div className="profile-container">
      {(!space && !isLoading && !isFetching && !isIdle)
        ? <SpaceNotExist />
        : (
          <>
            <Header remoteStates={{ space, users, offers }} />
            <OffersList remoteStates={{ space, offers }} />
            <OfferModal remoteStates={{ space, offers }} commands={{ ...basketCommands }} />
          </>
        )}
    </div>
  );
}

export default Profile;
